import subDays from 'date-fns/subDays';
import { useMemo } from 'react';

import { useRestaurantName } from 'reservations/account/providers/ConfigProvider';
import AvailabilitiesErrorContainer from 'reservations/availabilities/components/AvailabilitiesErrorContainer';
import { COMMON_DATETIME_FORMATS } from 'reservations/base/helpers/datetime';

type GetOutsideAvailabilityWindowMessageProps = {
  date: string;
  restaurantName: string;
  maxAdvanceDays: number;
  dayReservationWillBeAvailable: string;
  lastDayToMakeReservation: string;
};

const getOutsideAvailabilityWindowMessage = ({
  date,
  restaurantName,
  maxAdvanceDays,
  dayReservationWillBeAvailable,
  lastDayToMakeReservation
}: GetOutsideAvailabilityWindowMessageProps) =>
  `Reservations aren’t yet available for ${date}, and will be available on ${dayReservationWillBeAvailable}. ${restaurantName} only takes reservations ${maxAdvanceDays} days in advance. The last day reservations are available is ${lastDayToMakeReservation}.`;

export type OutsideAvailabilityWindowProps = {
  date: Date;
  maxAdvanceDays: number;
  lastDayToMakeReservation: Date;
};

export const OutsideAvailabilityWindow = ({
  date,
  maxAdvanceDays,
  lastDayToMakeReservation
}: OutsideAvailabilityWindowProps) => {
  const restaurantName = useRestaurantName();
  const formattedDate = useMemo(
    () => COMMON_DATETIME_FORMATS.dayDateOnly(date),
    [date]
  );
  const formattedDayReservationWillBeAvailable = useMemo(
    () => COMMON_DATETIME_FORMATS.dayDateOnly(subDays(date, maxAdvanceDays)),
    [date, maxAdvanceDays]
  );
  const formattedLastDayToMakeReservations = useMemo(
    () => COMMON_DATETIME_FORMATS.dayDateOnly(lastDayToMakeReservation),
    [lastDayToMakeReservation]
  );

  return (
    <AvailabilitiesErrorContainer
      message={getOutsideAvailabilityWindowMessage({
        restaurantName,
        maxAdvanceDays,
        date: formattedDate,
        dayReservationWillBeAvailable: formattedDayReservationWillBeAvailable,
        lastDayToMakeReservation: formattedLastDayToMakeReservations
      })}
    />
  );
};
